import ResizeContainer from './ResizeContainer'

export default ResizeContainer
